import { applicationSlice, getPasswordRules } from './slice';

export const Actions = {
  ...applicationSlice.actions,
  getPasswordRules,
};
